export default __webpack_public_path__ + "static/fahr_erlebnis_weiss_transparent-1b5c4fd38e8095627699d757d14f78c3.png";